import { Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { RxFormGroup } from '@rxweb/reactive-form-validators';
import { AuthService } from 'src/app/services/auth/auth.service';
import { faArrowDown } from '@fortawesome/free-solid-svg-icons';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-input-select',
  templateUrl: './input-select.component.html',
  styleUrls: ['./input-select.component.scss']
})
export class InputSelectComponent implements OnInit {

  @Input() formParent: RxFormGroup;
  @Input() label: string;
  @Input() isLabelTop: false;
  @Input() frmControl: string;
  @Input() options: any;
  @Input() placeHolder: string;
  @Input() isUser = false;
  @Input() isPaymentList = false;
  @Input() isDepartament = false;
  
  defaultColor: boolean = false;

  @Output() value = new EventEmitter<any>();  
  control: any;
  placeholder = '';
  faChevronDown = faChevronDown;

  isOpen = false;

  faArrowDown = faArrowDown;

  controlValueSubscription: Subscription;

  constructor(public auth: AuthService,) {}

  async ngOnInit(): Promise<void> {
    this.placeholder = this.placeHolder ? this.placeHolder : '';
    this.control = this.formParent.controls[this.frmControl];
  }
  /**
   * Metodo para setear la opcion seleccionada
   * @param option opcion
   */
  optionSelected(event: any): void {
    const selectedValue = event.target.value;
    this.verifySelectedValue(selectedValue);
    this.value.emit(selectedValue);

    this.onSelectChange(event);
  }

  customOptionSelected(selectedValue: any): void{
    this.verifySelectedValue(selectedValue);
    this.value.emit(selectedValue);
  }

  verifySelectedValue(value: any){
    if(!value || value.toString().trim() === ''){
      this.defaultColor = false;
    }
    else{
      this.defaultColor = true;
    }
  }

  // toggleSelect() {
  //   this.isOpen = !this.isOpen;
  // }
  onSelectChange(event: any) {
    const selectedValue = event.target.value;
    // Buscar la opción completa en el arreglo original
    const selectedOption = this.options.find(opt => opt.value === selectedValue);
    if (selectedOption && selectedOption.callback) {
        selectedOption.callback(); // Ejecutar el callback si existe
    }
  }

  executeCallback(option: any): void {
    option.callback();
  }

  toggleSelect() {
    setTimeout(() => {
      this.isOpen = !this.isOpen;
    }, 0);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['formParent'] || changes['frmControl']) {
      this.control = this.formParent.controls[this.frmControl];
      this.subscribeToValueChanges();
    }
  }

  private subscribeToValueChanges(): void {
    if (this.control) {
      this.controlValueSubscription = this.control.valueChanges.subscribe(value => {
        this.verifySelectedValue(value);
      });
      this.verifySelectedValue(this.control.value);
    }
  }

  ngOnDestroy(){
    if(this.controlValueSubscription){
      this.controlValueSubscription.unsubscribe();
    }
  }
  
}